document.addEventListener('DOMContentLoaded', (event) => {
  var coll = document.getElementsByClassName("collapsibleuz");
  for (var i = 0; i < coll.length; i++) {
    var content = coll[i].nextElementSibling;
    
    // Open the collapsible tab by default
    coll[i].classList.add("active");
    content.style.maxHeight = content.scrollHeight + "px";

    coll[i].addEventListener("click", function() {
      this.classList.toggle("active");
      var content = this.nextElementSibling;
      if (content.style.maxHeight) {
        content.style.maxHeight = null;
      } else {
        content.style.maxHeight = content.scrollHeight + "px";
      }
    });
  }
});


document.addEventListener('click', function(e) {
  const button = e.target.closest('.u-collapsible-toggle');
  if (!button) return;
  const item = button.closest('.u-collapsible-item');
  const content = item.querySelector('.u-collapsible-content');
  const isAlreadyActive = item.classList.contains('active');
  const allActiveItems = document.querySelectorAll('.u-collapsible-item.active');
  allActiveItems.forEach(activeItem => {
    activeItem.classList.remove('active');
    const activeContent = activeItem.querySelector('.u-collapsible-content');
    if (activeContent) {
      activeContent.style.maxHeight = null;
    }
  });
  if (!isAlreadyActive) {
    item.classList.add('active');
    content.style.maxHeight = content.scrollHeight + 'px';
  }
});
